import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

export interface BroadcastDevice {
  broadcast_device_id: number
  clinic_id: number
  examination_room_id?: number
  name?: string
  broadcast_type: string
  is_active: boolean
  created_at: string
  updated_at: string
  clinic?: {
    clinic_id: number
    clinic_name: string
    tags?: string[]
  }
}

export function useAllBroadcastDevices() {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<{ items: BroadcastDevice[]; total: number }>>(
    token ? `/api/broadcast-devices/all` : null,
    undefined,
    token ?? '',
  )

  return {
    devices: data?.data?.items || [],
    total: data?.data?.total || 0,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
